import React from "react";
import { EVENT_STATUS, catColor, frDate } from "@/lib/constants";

export default function EventsListView({ events, onEventClick }) {
  const sorted = [...events].sort((a, b) => (a.date || "").localeCompare(b.date || ""));
  return (
    <div className="space-y-2" data-testid="events-list-view">
      {sorted.map((e) => {
        const st = EVENT_STATUS[e.status] || EVENT_STATUS.prospect;
        return (
          <button key={e.id} data-testid={`list-event-${e.id}`} onClick={() => onEventClick(e.id)} className="flex w-full items-center gap-4 overflow-hidden rounded-xl border border-[#FF6A00]/25 bg-gradient-to-r from-[#FF6A00]/10 via-[#FF6A00]/[0.04] to-transparent p-4 text-left transition-all hover:border-[#FF6A00]/60 hover:from-[#FF6A00]/15">
            <div className="w-24 shrink-0 text-sm font-medium text-[#FF8A2B]">{frDate(e.date)}</div>
            <div className="min-w-0 flex-1">
              <p className="flex items-center gap-2 truncate font-medium text-white"><span className={`h-2 w-2 shrink-0 rounded-full ${catColor(e.category).dot}`} title={catColor(e.category).label} />{e.title}</p>
              <p className="truncate text-xs text-zinc-400">{[e.category, e.contact_name, e.location].filter(Boolean).join(" · ") || "—"}</p>
            </div>
            <span className={`shrink-0 rounded-full border px-2.5 py-1 text-xs font-medium ${st.cls}`}>{st.label}</span>
          </button>
        );
      })}
      {!sorted.length && <p className="rounded-xl border border-dashed border-zinc-800 p-8 text-center text-zinc-500" data-testid="events-list-empty">Aucun événement pour cette sélection.</p>}
    </div>
  );
}
